
import gallery01 from "../../assets/images/gallery-01.jpg"
import gallery02 from "../../assets/images/gallery-02.jpg"
import gallery03 from "../../assets/images/gallery-03.jpg"
import gallery04 from "../../assets/images/gallery-04.jpg"
import gallery05 from "../../assets/images/gallery-05.jpg"
import gallery06 from "../../assets/images/gallery-06.jpg"
import gallery07 from "../../assets/images/gallery-07.jpg"

const galleryImages = [
    gallery01,
    gallery07,
    gallery02,
    gallery06,
    gallery03,
    gallery04,
    gallery05,
    gallery07

]

export default galleryImages;